import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beach-wave',
  templateUrl: './beach-wave.component.html',
  styleUrls: ['./beach-wave.component.scss'],
})
export class BeachWaveComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
